import { useEffect } from 'react';
import { Option } from '@common-fe/common-fe';

import { EligibleExpense } from '../../FileScan/fileScan.types';
import { FormField } from '../../ReimburseMe.types';
import { useClaimInfoStore } from '../../store/useClaimInfo.store';
import { LastEditedField, useClaimInfoFieldsFilterStore } from '../stores/useClaimInfoFieldsFilter.store';

import { findOptionKeyByValue } from './findOption';

const ClaimInfoFieldOrder: { [key in LastEditedField]: number } = {
  [FormField.patient]: 1,
  [FormField.serviceDate]: 2,
  [FormField.amount]: 3,
  [FormField.service]: 4,
} as const;

interface Props {
  filteredExpense?: EligibleExpense;
  patientsOptions: Option[];
  servicesOptions: Option[];
}

const useSetMaxAmountExpenseOption = ({
  filteredExpense, patientsOptions, servicesOptions
}: Props) => {
  const { filterByValues, lastEditedField } = useClaimInfoFieldsFilterStore();
  const { handleSetValues } = useClaimInfoStore();

  useEffect(() => {
    if (!filteredExpense || !lastEditedField) {
      return;
    }

    const lastEditedFieldOrder = ClaimInfoFieldOrder?.[lastEditedField];

    if (filteredExpense?.patient && ClaimInfoFieldOrder.patient > lastEditedFieldOrder) {
      handleSetValues({ patient: findOptionKeyByValue(patientsOptions, filteredExpense?.patient) });
    }

    if (filteredExpense?.serviceDates?.length && ClaimInfoFieldOrder.serviceDate > lastEditedFieldOrder) {
      handleSetValues({ serviceDate: filteredExpense?.serviceDates[0] });
    }

    if (filteredExpense?.amount && ClaimInfoFieldOrder.amount > lastEditedFieldOrder) {
      handleSetValues({ amount: filteredExpense?.amount });
    }

    if (filteredExpense?.service && ClaimInfoFieldOrder.service > lastEditedFieldOrder) {
      handleSetValues({ service: findOptionKeyByValue(servicesOptions, filteredExpense?.service) });
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterByValues?.patient, filterByValues?.service, filterByValues?.serviceDates]);
};

export default useSetMaxAmountExpenseOption;
